// src/hooks/useWOW.js
import { useEffect } from "react";

export const useWOW = () => {
  useEffect(() => {
    // Wait for WOW.js to be available
    const initWOW = () => {
      if (window.WOW) {
        const wow = new window.WOW({
          offset: 150,
          mobile: false,
        });
        wow.init();
      }
    };

    // Try to initialize immediately if WOW is already available
    if (window.WOW) {
      initWOW();
    } else {
      // Poll for WOW.js to be available
      const interval = setInterval(() => {
        if (window.WOW) {
          initWOW();
          clearInterval(interval);
        }
      }, 100);

      // Cleanup interval after 5 seconds to prevent infinite polling
      setTimeout(() => clearInterval(interval), 5000);
    }
  }, []);
}; 